import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext.jsx';
import { homeForRole } from '../layouts/navigation.js';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <div className="centered-page">
      <h1>404</h1>
      <p>{t('errors.pageNotFound')}</p>
      <Link className="btn btn--primary" to={user ? homeForRole(user.role) : '/login'}>
        {t('common.back')}
      </Link>
    </div>
  );
};

export const ForbiddenPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <div className="centered-page">
      <h1>403</h1>
      <p>{t('errors.FORBIDDEN')}</p>
      <Link className="btn btn--primary" to={user ? homeForRole(user.role) : '/login'}>
        {t('common.back')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
